/**
 * 서류/사진 등록 — 메인 페이지 (소유자)
 *
 * Ui.Div 타겟. blade 에 주입된 초기 payload 로 최초 렌더, 이후 refresh() 로 재조회.
 *
 * BS(UploadSheet) 가 닫히면 refresh() 를 호출해 배지·프리뷰 등 서버 상태와 동기화.
 */
import Util from '../../../Common/Util';
export default class Index {
    constructor() {
        this.data = null;
        this._bsCloseBound = false;
    }

    destroy() {
        $(`#${this.id}`).off();
        $j.Common.EventBus.offNamespace($j.getNS(this));
    }

    init() {
        this.data = (this.data || this._data) || (this.data = null);
        if (!this.data && this.data !== undefined) { /* noop */ }

        // data 우선순위: 생성자 주입값 → 명시 세팅 → 빈객체
        if (!this.data) this.data = {};

        // Ui.Div.open 에서 this.data = options.data 로 세팅되므로 여기서 참조만
        this.draw();
        this.initHandler();
        this.subscribeBus();
    }

    // ─── EventBus ──────────────────────────────────

    subscribeBus() {
        const self = this;
        const ns = $j.getNS(this);

        // BS(UploadSheet) 가 닫히면 서버와 재동기화
        $j.Common.EventBus.on(ns, 'BS:close', (e, payload) => {
            if (!payload || payload.target !== '$j.F.Docs.v1.UploadSheet') return;
            self.refresh();
        });

        // 이미지 편집 저장 → 편집기 iframe 제거 + 페이지 상태 부분 갱신
        $j.Common.EventBus.on(ns, 'img-editor:saved', (e, payload) => {
            const imgId = payload.imgId;
            const docId = G5['currentEditDocId'];
            $.ajax({
                type: 'POST', url: '/m/ajax/docs/save', dataType: 'json',
                data: { docId, imgId },
                success: (r) => {
                    if (!r.result) { Util.swalert('시스템에러로 저장하지 못했습니다.'); return; }
                    $('#' + G5['EDITOR_ID']).remove();
                    // uploadsByCode 안의 해당 행 갱신
                    self._applyImageEditResult(r);
                    $j.Common.EventBus.trigger('docs:image-edited', {
                        docId: r.doc_id, dataCode: r.data_code,
                        imgRelId: r.img_rel_id, imageUrl: r.image_url, thumbUrl: r.thumb_url
                    });
                }
            });
        });
    }

    _applyImageEditResult(r) {
        const list = this.data?.uploadsByCode?.[r.data_code] || [];
        list.forEach(row => {
            if (row && row[7] == r.doc_id) {
                row[1]  = r.image_url;
                row[2]  = r.thumb_url;
                row[10] = r.img_rel_id;
            }
        });
    }

    // ─── 렌더링 ──────────────────────────────────

    draw() {
        const d = this.data || {};
        $(`#${this.id}`).html(`
            <div class="dv1">
                ${this._renderIntro()}
                ${this._renderDocsSection(d)}
                ${this._renderAutoSendCheckboxes(d)}
                ${this._renderDriversSection(d)}
            </div>
        `);
    }

    // 안내문 — 구 화면에 흩어져 있던 문구를 한 카드로 묶는다. 문구 자체는 사업 안내문이라 그대로 옮겼다.
    _renderIntro() {
        return `
        <div class="dv1-note">
            <div class="dv1-note-lead">
                <i class="fas fa-circle-info"></i>
                <span>등록된 서류는 발주자 요청시, 열람하여 업체에 제출됩니다</span>
            </div>
            <div class="dv1-note-hook">장비차량 서류등록 한번으로 간편하게 서류관리</div>
            <div class="dv1-note-body">
                <div class="dv1-note-li"><i class="fas fa-circle"></i><span>장비 차량번호에 맞는 각각의 사본서류를 등록합니다.</span></div>
                <div class="dv1-note-li"><i class="fas fa-circle"></i><span>보유하고 있는 장비차량에 맞는 각각의 서류를 카메라로 바로 찍어 올리거나, 갤러리에 저장된 사본을 업로드할 수 있습니다.</span></div>
                <div class="dv1-note-li"><i class="fas fa-circle"></i><span><b>개인정보 보호를 위해 주민번호 뒷자리는 삭제 후 등록</b>해 주세요.</span></div>
            </div>
        </div>`;
    }

    _renderDocsSection(d) {
        const titles = d.titles || [];
        const uploads = d.uploadsByCode || {};
        const done = titles.filter(t => (uploads[t.doc_code] || []).length > 0).length;
        const boxesHtml = titles.map((t, i) => this._renderBox({
            titleIdx: i, title: t, uploads: uploads[t.doc_code] || [],
            hasDate: 1, moretype: 1, xStep: 1, seltyett: 'selthsaseditnum'
        })).join('');
        return `
        <section class="jb-card" id="docDivBox">
            <h2 class="jb-card-hd">
                <i class="fas fa-folder-open"></i>기본 공통서류
                <span class="jb-card-hd-sub">${done}/${titles.length} 등록</span>
            </h2>
            <div class="dv1-grid" id="inshowtype1">${boxesHtml}</div>
        </section>`;
    }

    // 서류 타일 1개 (레거시 showDtas 포팅)
    _renderBox(ctx) {
        const t = ctx.title;
        const uploads = ctx.uploads;
        const uploadCnt = uploads.length;
        const dataCode = ctx.xStep == 1 ? t.doc_code : t.num;
        const docName = t.doc_name_full || t.doc_name || '';
        const eTit    = t.doc_name || docName;

        let showNum, eafn, oldval;
        if (uploadCnt > 0) {
            const first = uploads[0];
            eafn    = first[1];
            oldval  = first[4] || '';
            showNum = first[7];
        } else {
            eafn    = '';
            oldval  = '';
            showNum = -1;
        }
        // 업로드 행이 없어도 g5_company 등록값(co_number/co_bank1)이 있으면 사업자번호/계좌번호 칸에 표시
        if (!oldval) {
            if (dataCode == 12 && this.data?.bankDisplay) oldval = this.data.bankDisplay;
            else if (dataCode == 5 && this.data?.coNumber) oldval = this._formatBizNoForDisplay(this.data.coNumber);
        }

        return this._tileHtml({
            uploadCnt, eafn, eTit,
            // 공통서류(사업자번호/계좌번호)의 oldval 은 날짜가 아니라 번호라 만료표시를 하지 않는다
            meta: '',
            attrs: `data-title-idx="${ctx.titleIdx}"
                    data-data-code="${dataCode}"
                    data-doc-name="${this._escAttr(docName)}"
                    data-has-date="${ctx.hasDate}"
                    data-old-val="${this._escAttr(oldval)}"
                    data-show-num="${showNum}"
                    data-moretype="${ctx.moretype}"
                    data-seltyett="${ctx.seltyett}"
                    id="userDataphoto_${dataCode}_1"
                    data_rsno="${showNum}"`,
        });
    }

    /**
     * 서류 타일 공통 마크업 — Detail.js 와 같은 모양이라 렌더 규칙을 한곳에 둔다.
     * (구 마크업의 체크박스·hidden(eadataval_*)·배지 id(eadatacnt_*)는 읽는 쪽이 없어 걷어냈다.
     *  누르면 아무 일도 일어나지 않는 체크박스가 서류마다 붙어 있었다)
     */
    _tileHtml({ uploadCnt, eafn, eTit, meta, attrs }) {
        const has = uploadCnt > 0;
        const thumbStyle = has && eafn ? ` style="background-image:url('${eafn}')"` : '';
        // 배지는 '2장 이상'일 때만. 1장짜리 체크 표시는 사진이 이미 등록됨을 말해줘서 군더더기다.
        const badge = uploadCnt > 1 ? `<span class="doc-tile-badge">${uploadCnt}</span>` : '';
        const ico = has ? '' : '<i class="fas fa-camera doc-tile-ico"></i>';
        return `
        <button type="button" class="doc-tile js-doc-box${has ? '' : ' is-empty'}" ${attrs}>
            <span class="doc-tile-thumb"${thumbStyle}>${ico}${badge}</span>
            <span class="doc-tile-name">${this._escHtml(eTit)}</span>
            ${meta || ''}
        </button>`;
    }

    _renderAutoSendCheckboxes(d) {
        const a = d.autoAllowShare || 0;
        const b = d.autoSoojooSet  || 0;
        const chk = (v) => v ? 'checked' : '';
        // 값 전송 규칙(_onClickAutoSend)은 그대로다. 체크박스는 들여쓰지 않고 한 줄로 맞춘다.
        return `
        <section class="jb-card">
            <h2 class="jb-card-hd"><i class="fas fa-paper-plane"></i>서류 자동 제출</h2>
            <label class="dv1-auto-li">
                <input type="checkbox" class="js-auto-send" id="ach1" ${chk(a>0)}>
                <span>수주시, 등록된 <em>기본서류만</em> 자동 제출 동의</span>
            </label>
            <label class="dv1-auto-li">
                <input type="checkbox" class="js-auto-send" id="ach2" ${chk(a>=2)}>
                <span>수주시, 등록된 <em>기본 + 장비서류</em> 자동 제출</span>
            </label>
            <label class="dv1-auto-li">
                <input type="checkbox" class="js-auto-send" id="ach3" ${chk(a>=3)}>
                <span>수주시, 등록된 <em>기본 + 장비 + 개인서류</em> 자동 제출</span>
            </label>
            <label class="dv1-auto-li is-sep">
                <input type="checkbox" class="js-auto-send" id="ach4" ${chk(b>0)}>
                <span><em>발주시</em>, 등록된 <em>기본서류</em> 수주자에게 보내기</span>
            </label>
        </section>`;
    }

    _renderDriversSection(d) {
        // 발주자(장비 미보유)는 이 화면에 들어와도 관리할 차량이 없다 — 카드째 숨긴다.
        if (d.isBaljooja) return '';

        const drivers = d.drivers || [];
        const rows = drivers.map(dr => {
            // 업종(스카이 …) + 기종(1톤 5톤미만 28M). 장비 미배정 소속자는 둘 다 비어 줄 자체를 그리지 않는다.
            const spec = [dr.car_type, dr.car_spec].filter(Boolean).join(' · ');
            // 행 안에 버튼이 둘이라 바깥을 div 로 둔다 — button 중첩은 브라우저가 DOM 을 쪼개버린다.
            //   가상번호 알약 → 가상번호 설정 BS / 나머지 전체 → 그 차량의 서류등록 페이지
            return `
            <div class="dv1-car">
                <button type="button" class="dv1-car-no js-edit-vnum" aria-label="가상번호 설정">
                    ${this._escHtml(dr.vnum || '-')}
                </button>
                <button type="button" class="dv1-car-main js-edit-driver" data-num="${dr.num}" data-carnum="${dr.carnum}">
                    <span class="dv1-car-txt">
                        <span class="dv1-car-head">
                            <span class="dv1-car-plate">${this._escHtml(dr.car_platenumber || '차량 미등록')}</span>
                            <span class="dv1-car-name">${this._escHtml(dr.mem_name)}</span>
                        </span>
                        ${spec ? `<span class="dv1-car-spec">${this._escHtml(spec)}</span>` : ''}
                    </span>
                    <span class="dv1-car-cnt${dr.regcnt > 0 ? '' : ' is-zero'}">${dr.regcnt > 0 ? dr.regcnt + '건' : '미등록'}</span>
                    <i class="fas fa-chevron-right dv1-car-go"></i>
                </button>
            </div>`;
        }).join('');
        return `
        <section class="jb-card">
            <h2 class="jb-card-hd">
                <i class="fas fa-truck"></i>차량별 서류등록
                <span class="jb-card-hd-sub">${drivers.length}대</span>
            </h2>
            ${rows}
        </section>`;
    }

    // ─── 이벤트 ──────────────────────────────────

    initHandler() {
        const self = this;
        const $el = $(`#${this.id}`);

        $el.on('click', '.js-doc-box', function(){ self._onClickDocBox($(this)); });

        $el.on('click', '.js-edit-driver', function(){
            const num = $(this).data('num');
            const carnum = $(this).data('carnum');
            document.location.href = `/m/docs/v1/car/${carnum}?editmemnum=${num}`;
        });

        $el.on('click', '.js-edit-vnum', () => self._openVnumSheet());

        $el.on('click', '.js-auto-send', () => self._onClickAutoSend());
    }

    /**
     * 종류의 총 장수 상한 — 마스터(`g5_document_types.max_pages`)가 `titles` 에 실려 온다.
     * 커스텀 서류(doc_code>100)는 `titles` 에 없어 0 이 되고, 시트가 기본값으로 돌아간다.
     */
    _maxPagesOf(dataCode) {
        const t = (this.data?.titles || []).find((x) => x.doc_code == dataCode);
        return t ? (parseInt(t.max_pages) || 0) : 0;
    }

    /**
     * 더 올릴 수 있는 장수 — **서버가 센다** (DocService::remainByCode).
     * 화면의 업로드 목록으로는 못 센다: 공통서류 칸은 소속 기사 전원의 장을 모아 보여준다.
     */
    _remainPagesOf(dataCode) {
        const r = this.data?.remainByCode || {};
        return (r[dataCode] == null) ? null : (parseInt(r[dataCode]) || 0);
    }

    _onClickDocBox($box) {
        const idx      = parseInt($box.data('title-idx'));
        const dataCode = parseInt($box.data('data-code'));
        const docName  = $box.data('doc-name');
        const hasDate  = parseInt($box.data('has-date'));
        const oldVal   = $box.data('old-val') || '';
        const showNum  = parseInt($box.data('show-num'));
        const moretype = parseInt($box.data('moretype'));
        const seltyett = $box.data('seltyett') || '';

        const uploads = this.data.uploadsByCode?.[dataCode] || [];

        $j.Ui.BS.open({
            target: '$j.F.Docs.v1.UploadSheet',
            fixedHeight: true,
            data: {
                tar: $box[0], docName, hasDate, dataCode, oldDate: oldVal,
                subCode: 1, tarMaxnum: 1, showImg: '',
                showNum, intype: 0, sstype: moretype, seltyett,
                existingData: uploads,
                maxPages: this._maxPagesOf(dataCode),
                remainPages: this._remainPagesOf(dataCode),
                editmembernum: this.data.editmemnum,
                carnum: this.data.carnum || 0,
                userGroups: (this.data.userGroups || '').split('|').filter(Boolean),
                bankLocked: !!this.data.bankLocked,
                coNumberLocked: !!this.data.coNumber,
                // 사업자정보 — 관리자 기사관리 '사업자정보'(g5_company)와 같은 값이다
                coNumber: this.data.coNumber || '',
                coTitle: this.data.coTitle || '',
                coCeoname: this.data.coCeoname || '',
                coBirth: this.data.coBirth || '',
            }
        });
    }

    // 가상번호 설정 BS — 위치설정(/m/setting/gps)과 공용 모듈. 저장되면 목록의 번호·정렬이 바뀌니 재조회.
    _openVnumSheet() {
        $j.Ui.BS.open({
            target: '$j.F.Mobile.VnumSheet',
            fixedHeight: true,
            data: { onSaved: () => this.refresh() },
        });
    }

    _onClickAutoSend() {
        const objA = document.getElementById('ach1');
        const objB = document.getElementById('ach2');
        const objC = document.getElementById('ach3');
        const objD = document.getElementById('ach4');
        let nn = 0, ss = 0;
        if (objC.checked) { objA.checked = true; objB.checked = true; nn = 3; }
        else if (objB.checked) { objA.checked = true; nn = 2; }
        else if (objA.checked) { nn = 1; }
        if (objD.checked) ss = 1;

        $.ajax({
            type: 'POST', url: '/m/ajax/setting/doc-auto-send',
            data: { autosetval: nn, autosooset: ss }
        });
    }

    // ─── Refresh ──────────────────────────────────

    refresh() {
        const self = this;
        const scrollTop = $(window).scrollTop();
        $.ajax({
            type: 'GET', url: '/m/ajax/docs/v1/index', dataType: 'json',
            success: (res) => {
                if (!res.result) return;
                self.data = res.data;
                self.draw();
                $(window).scrollTop(scrollTop);
            }
        });
    }

    // ─── utils ──────────────────────────────────

    _escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    _escAttr(s) { return this._escHtml(s); }

    // 사업자번호 표시용 포맷 (10자리 숫자 → XXX-XX-XXXXX)
    _formatBizNoForDisplay(s) {
        const d = String(s || '').replace(/\D/g, '');
        if (d.length === 10) return `${d.slice(0,3)}-${d.slice(3,5)}-${d.slice(5)}`;
        return s;
    }
}
